import { MediaContentDTO } from "@touche-lts/panel-ui/dist";

export enum StatisticsDatePeriod {
    WEEK = 'Past week',
    MONTH = 'Past month',
    YEAR = 'Past year'
}

export interface StatisticsHighlights {
    totalRevenue: number;
    stores: number;
    activeProducts: number;
    productsSold: number;
    orders: number;
    bestSellingProduct: any;
    visitingUsers: number;
}

export interface StoreAdminHighlightsDTO {
    totalOrders: number;
    totalRevenue: number;
    totalProducts: number;
    totalVisitors: number;
    productsSold: number;
    bestSellingProduct: any;
    periodStart: string;
    periodEnd: string;
}

export interface StatisticsPayloadDTO {
    dateEnd: string;
    dateStart: string;
    name: string;
    revenueTodayMax: number;
    revenueTodayMin: number;
    revenueTotalMax: number;
    revenueTotalMin: number;
}

export interface StatisticsTableEntryDTO {
    id: number;
    version: number;
    createdAt: string;
    lastUpdated: string;
    date: string;
    master: boolean;
    revenueTotal: number;
    revenueToday: number;
    activeSkus: number;
    images:MediaContentDTO[];
    productName: string;
    sold?: number;
    stock?: number;
    variants?: number;
}